/* KartComms — support article: jump-nav scroll spy.

   No scroll-reveal: content is never gated behind a transition. The one job
   here is highlighting the jump-nav card for the section you are reading.

   IntersectionObserver is preferred, but it is inert in some rendering
   contexts (headless renderers, backgrounded tabs, certain preview surfaces),
   so a scroll fallback takes over if the observer never reports. */
(function () {
  'use strict';

  var root = document.querySelector('[data-kc-article]');
  if (!root) return;

  var cards = root.querySelectorAll('[data-navcard]');
  if (!cards.length) return;

  var byKey = {};
  var sections = [];
  Array.prototype.forEach.call(cards, function (card) {
    var key = card.getAttribute('data-navcard');
    var el = document.getElementById(key);
    if (!el) return;
    byKey[key] = card;
    sections.push(el);
  });
  if (!sections.length) return;

  function setActive(id) {
    Object.keys(byKey).forEach(function (key) {
      byKey[key].classList.toggle('is-active', key === id);
    });
  }

  // The section straddling the reading line, a quarter down the viewport.
  function currentFromScroll() {
    var line = window.innerHeight * 0.25;
    var id = null;
    sections.forEach(function (el) {
      var box = el.getBoundingClientRect();
      if (box.top <= line && box.bottom > line) id = el.id;
    });
    return id;
  }

  function useScrollFallback() {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        setActive(currentFromScroll());
      });
    }, { passive: true });
    setActive(currentFromScroll());
  }

  if (!('IntersectionObserver' in window)) {
    useScrollFallback();
    return;
  }

  var visible = {};
  var reported = false;
  var spy = new IntersectionObserver(function (entries) {
    reported = true;
    entries.forEach(function (entry) {
      visible[entry.target.id] = entry.isIntersecting;
    });
    var current = null;
    sections.forEach(function (el) { if (!current && visible[el.id]) current = el.id; });
    setActive(current);
  }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

  sections.forEach(function (el) { spy.observe(el); });

  window.setTimeout(function () {
    if (reported) return;
    spy.disconnect();
    useScrollFallback();
  }, 1000);
})();
